export default __webpack_public_path__ + "static/media/velaGreen.8ece3ce6.png";